import React from "react";
import ElectricityConsumption from "./ConsumptionByFacility";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Scope2Layout from "../../../Layout/Scope2Layout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";

const Electricity = () => {
  return (
    <MainDashboardLayout sidebar={<Scope2Layout />}>
      <Unauthorized requiredModule="Environment | Scope 2 | Electricity">
        <ElectricityConsumption />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Electricity;